var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',[_c('rotate-square3',{attrs:{"size":_vm.size,"color":_vm.color}}),_c('div',{staticClass:"loader__text",attrs:{"role":"progressbar"}},[_vm._v("Cargando")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }